export const TURBO_LIVE_ID = 'turboLive';
export const SPORT_OVERVIEW_ID = 'turbolive-overview';

export const SORT_BY_START_TIME = 'startTime';
export const SORT_BY_TOURNAMENTS = 'tournaments';
export const LOCAL_STORAGE_TUTORIAL = 'turboLiveTutorial';
export const LOCAL_STORAGE_SORT = 'turboLiveSortBy';
export const LOCAL_STORAGE_FILTER_RADAR = 'turboLiveFilterRadar';
export const LOCAL_STORAGE_FILTER_STREAM = 'turboLiveFilterStream';
export const CHANNEL_PORTAL = 'portal';
export const CHANNEL_MOBILE = 'mobile';
export const FILTER_SHOW_CASHIN = 'true';
export const FILTER_HIDE_CASHIN = 'false';

export const SESSION_STORAGE_TOURNAMENTS = 'turboLive.collapsed.tournaments';

export const BREAKPOINTS = {
    onDesktop: 1280,
    x_2200: 2300,
    ultra: 1921,
    xxxxl: 1920,
    x_1760: 1760,
    x_1680: 1680,
    xxxl: 1500,
    xxl: 1400,
    xl: 1200,
    lg: 1100,
    md: 768,
    sm: 350,
    xs: 0
};

export const MATCH_EXTRAS = {
    scoreboardType: 'scoreboardType',
    rainDelay: 'rainDelay',
    noAdvantage: 'noAdvantage'
};

export const LS_FILTER_SHOW_CASHIN = 'tlvFilterShowCashin';
export const COLLAPSED_SPORTS_PATH = ['turboLive', 'collapsedSports'];
